"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var scenario_template_utils_1 = require("../template-checkbox-tree/scenario-template.utils");

var dental_template_data_1 = require("../dental-template-checkbox-tree/dental-template.data");

var dental_template_checkbox_tree_data_1 = require("../dental-template-checkbox-tree/dental-template-checkbox-tree.data");

var insert_scenario_template_styles_1 = require("./insert-scenario-template.styles");

var gallery_card_component_1 = __importDefault(require("../../common-components/gallery-card/gallery-card.component"));

var dental_template_checkbox_tree_component_1 = __importDefault(require("../dental-template-checkbox-tree/dental-template-checkbox-tree.component"));

var EMPTY_ERROR_MESSAGE = '挿入するテンプレートを選択してください';

var InsertScenarioTemplate = function InsertScenarioTemplate(_ref) {
  var handleInsertScenarioTemplate = _ref.handleInsertScenarioTemplate;

  var _react_1$useState = react_1.useState(''),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      errorMessage = _react_1$useState2[0],
      setErrorMessage = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState([]),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      checkedIds = _react_1$useState4[0],
      setCheckedIds = _react_1$useState4[1];

  var onClick = function onClick() {
    var error = !checkedIds.length ? EMPTY_ERROR_MESSAGE : '';
    setErrorMessage(error);
    if (error) return;
    var filteredNodeMap = scenario_template_utils_1.filterTemplate(dental_template_data_1.DENTAL_TEMPLATE, dental_template_data_1.DENTAL_TEMPLATE_TOP_ID, dental_template_checkbox_tree_data_1.DENTAL_OPTION_POSITIONS_MAP, checkedIds);
    handleInsertScenarioTemplate(filteredNodeMap);
  };

  return react_1.default.createElement("div", null, react_1.default.createElement(gallery_card_component_1.default, null, react_1.default.createElement(dental_template_checkbox_tree_component_1.default, {
    onCheckedChange: setCheckedIds
  })), react_1.default.createElement(insert_scenario_template_styles_1.ButtonBoxDiv, {
    onClick: onClick
  }, errorMessage && react_1.default.createElement(insert_scenario_template_styles_1.ErrorMessageSpan, null, errorMessage), react_1.default.createElement(insert_scenario_template_styles_1.StyledButton, {
    variant: "outlined",
    color: "primary"
  }, "\u4F5C\u6210")));
};

exports.default = InsertScenarioTemplate;